import { Box, SxProps, Theme } from '@mui/material';
import abgLogo from 'assets/abg-logo.png';

const rootStyles: SxProps<Theme> = {
  width: '100%',
  maxHeight: 104,
  padding: 1,
};

export function ABGLogo() {
  return <Box component='img' sx={rootStyles} src={abgLogo} alt='American Bath Group Logo' />;
}
